import { UserRole } from '../types';

/**
 * Where a signed-in user's own "home" is.
 *
 * `/` is the tenant's PUBLIC face — the marketing landing page, ComingSoon, or a
 * bounce to /login depending on `sell_courses` + `tenants.is_published` (App.tsx).
 * It is never a signed-in destination, so anything that means "take me home"
 * inside the app shell resolves through here rather than linking to `/`.
 */
export const getDefaultLanding = (userRole: UserRole): string => {
  switch (userRole) {
    case UserRole.ADMIN:
      return '/admin';
    case UserRole.INSTRUCTOR:
      return '/instructor';
    default:
      return '/browse';
  }
};
